<div class="opportunity-grid-root">
  <app-header>{{labels.opportunities}}</app-header>
  <div
    *ngIf="rewards.length || loading"
    class="grid rewards"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullRewards()">
    <ng-container *ngFor="let reward of rewards">
      <app-reward-card [disabled]="disableAll" (redeeming)="redeeming($event)" small class="grid-item" [reward]="reward">
      </app-reward-card>
    </ng-container>
    <div class="loading grid-item">
      <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>
    </div>
  </div>
  <app-icon-paragraph *ngIf="rewards && !rewards.length && !loading"
                      icon="list_alt"
                      [title]="labels.notFound"
                      [paragraph]="labels.notFoundDescription">
  </app-icon-paragraph>
</div>
